module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("An Amish Christmas")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "page-template.xpgt",
      "rel": "stylesheet",
      "type": "application/vnd.adobe.page-template+xml"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0003-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONTENTS")])])])]), _c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_c('p', {
    staticClass: "ser"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Contents",
      "id": "p0003-d6e10",
      "src": "images/9781595548566_INT_0003_002.jpg"
    }
  }), _c('br'), _c('br'), _c('br')])])]), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-03-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageiii"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/chapter2",
      "id": "c_1"
    }
  }, [_vm._v("GLOSSARY"), _c('span', {
    staticClass: "small"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-03-2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter5",
      "id": "c_2"
    }
  }, [_vm._v("CHAPTER ONE"), _c('span', {
    staticClass: "small"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-04-1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/chapter6",
      "id": "c_3"
    }
  }, [_vm._v("CHAPTER TWO")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-04-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter7",
      "id": "c_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-05-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter8",
      "id": "c_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-05-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter9",
      "id": "c_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-06-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter10",
      "id": "c_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-06-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter11",
      "id": "c_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-07-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter12",
      "id": "c_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-07-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter13",
      "id": "c_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER NINE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-08-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter14",
      "id": "c_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-08-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter15",
      "id": "c_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER ELEVEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-09-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter16",
      "id": "c_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWELVE")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-09-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter17",
      "id": "c_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THIRTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-10-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter18",
      "id": "c_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOURTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-08-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter19",
      "id": "c_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIFTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-09-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter20",
      "id": "c_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIXTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-09-4"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter21",
      "id": "c_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVENTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-10-3"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter22",
      "id": "c_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHTEEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-10-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter57",
      "id": "c_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("READING GUIDE"), _c('span', {
    staticClass: "small"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-11-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter58",
      "id": "c_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AMISH RECIPES"), _c('span', {
    staticClass: "small"
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-11-2"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Excerpt",
      "id": "c_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EXCERPT FROM SEEK ME WITH ALL YOUR HEART")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "p0003-12-1"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/chapter60",
      "id": "c_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AUTHOR BIO"), _c('span', {
    staticClass: "small"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 66
// module chunks = 0